<template>
    <div>
        <b-modal
                :no-close-on-backdrop="true"
                :ref="'form-create-contact'"
                :id="'form-create-contact'"
                :lazy="true"
                @shown="shownModal"
                :title="isUpdate ? 'Contactpersoon bewerken' : 'Contactpersoon aanmaken'"
                size="xl"
                scrollable>
            <div>
                <div class="row mb-3">

                    <div class="col-md-5">
                        <formdata :form="form" :onlyImportant="false"></formdata>
                    </div>

                    <div class="col-md-7 border-hr border-left">
                        <div class="d-flex justify-content-between mb-2">
                            <div>
                                <strong class="sub-title d-block">Contactpersoon:</strong>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label col-form-label-sm">
                                Aanhef:
                            </label>
                            <div class="col-sm-8">
                                <div class="row">
                                    <div class="col-12 col-sm-6" :class="isInvalid('con-gender')" v-for="gender in genders">
                                        <div class="form-check form-check-inline">
                                            <b-form-radio data-hj-whitelist class="form-check-input" :class="isInvalid('con-gender')" name="gender" v-model="contact.gender" type="radio" :id="gender.key" :value="gender.value">{{gender.key}}</b-form-radio>
                                        </div>
                                    </div>
                                    <div v-if="isInvalid('con-gender')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['con-gender'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="con-letters" class="col-sm-4 col-form-label col-form-label-sm">
                                Voorletter(s):
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist :ref="'con-letters'" type="text" class="form-control form-control-sm"
                                       v-model="contact.letters" :class="isInvalid('con-letters')" id="con-letters" placeholder="" maxlength="15">
                                <div v-if="isInvalid('con-letters')" class="invalid-feedback">
                                    {{this.validationErrors['con-letters'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="con-firstname" class="col-sm-4 col-form-label col-form-label-sm">
                                Voornaam:
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist :ref="'con-firstname'" type="text" class="form-control form-control-sm"
                                       v-model="contact.firstname" :class="isInvalid('con-firstname')" id="con-firstname" placeholder="">
                                <div v-if="isInvalid('con-firstname')" class="invalid-feedback">
                                    {{this.validationErrors['con-firstname'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label for="con-lastname" class="col-sm-4 col-form-label col-form-label-sm">
                                Tuss. + Achternaam:
                            </label>

							<div class="col-sm-3 pb-3">
								<input data-hj-whitelist :ref="'con-prefix'" type="text" class="form-control form-control-sm"
									   v-model="contact.prefix" :class="isInvalid('con-prefix')" id="con-prefix" placeholder="">
								<div v-if="isInvalid('con-prefix')" class="invalid-feedback">
									{{this.validationErrors['con-prefix'].join(', ')}}
								</div>
							</div>

                            <div class="col-sm-5 pl-sm-0">
                                <input data-hj-whitelist :ref="'con-lastname'" type="text" class="form-control form-control-sm"
                                       v-model="contact.lastname" :class="isInvalid('con-lastname')" id="con-lastname" placeholder="">
                                <div v-if="isInvalid('con-lastname')" class="invalid-feedback">
                                    {{this.validationErrors['con-lastname'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <!--<div class="form-group row">
                            <label for="con-title" class="col-sm-4 col-form-label col-form-label-sm">
                                Titel/aanhef: {{ contact.title }}
                            </label>
                            <div class="col-sm-8">
                                <afas-title-select v-model="contact.title" id="con-title"></afas-title-select>
                                <div v-if="isInvalid('con-title')" class="invalid-feedback">
                                    {{this.validationErrors['con-title'].join(', ')}}
                                </div>
                            </div>
                        </div>-->
                        <div class="form-group row">
                            <label for="con-function" class="col-sm-4 col-form-label col-form-label-sm">
                                Functie:
                                <small class="text-muted">(optioneel)</small>
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist :ref="'con-function'" type="text" class="form-control form-control-sm"
                                       v-model="contact.function" :class="isInvalid('con-function')" id="con-function" placeholder="">
                                <div v-if="isInvalid('con-function')" class="invalid-feedback">
                                    {{this.validationErrors['con-function'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label col-form-label-sm">
                                Telefoonnummer:
                            </label>
                            <div class="col-sm-8 phone-input">
                                <vue-tel-input ref="con-phone" v-model="contact.phone" :class="isInvalid('con-phone')" id="con-phone" placeholder="+31 xxxxxxxx" @onInput="validate" defaultCountry="nl"></vue-tel-input>
                                <div v-if="isInvalid('con-phone')" class="invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['con-phone'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="con-email" class="col-sm-4 col-form-label col-form-label-sm">
                                E-mailadres:
                            </label>
                            <div class="col-sm-8">
                                <input data-hj-whitelist type="email" class="form-control form-control-sm"
                                       v-model="contact.email" :class="isInvalid('con-email')" id="con-email" placeholder="">
                                <div v-if="isInvalid('con-email')" class="invalid-feedback">
                                    {{this.validationErrors['con-email'].join(', ')}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-4">
                                <strong>Adres:</strong>
                            </div>
                            <div class="col-8">
                                <b-form-checkbox data-hj-whitelist v-model="contact.copyAddress" id="con-copy-address">Adres overnemen van organisatie.</b-form-checkbox>
                            </div>
                        </div>

                        <div v-show="!contact.copyAddress">
                            <afas-address-input ref="address" id="address" v-model="contact.address"></afas-address-input>

                            <div class="form-group row">
                                <div class="col-4">
                                    <strong>Postadres:</strong>
                                </div>
                                <div class="col-8">
                                    <b-form-checkbox data-hj-whitelist v-model="contact.samePostaddress" id="con-same-postaddress">Postadres is hetzelfde als het adres.</b-form-checkbox>
                                </div>
                            </div>

                            <afas-address-input ref="postaddress" v-show="!contact.samePostaddress" id="postaddress" v-model="contact.postaddress"></afas-address-input>
                        </div>

                    </div>

                </div>

            </div>
            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <p class="text-muted">
                        <small>Bepaalde velden zijn al automatisch ingevuld op basis van de ontvangen gegevens.</small>
                    </p>
                </div>
                <div class="btn-group float-right">
                    <button class="btn btn-light" @click="hide">
                        Annuleren
                    </button>
                    <button class="btn btn-primary" @click="save">
                        Opslaan & Synchroniseren <i class="fas fa-check-circle"></i>
                    </button>
                </div>
            </div>
        </b-modal>

        <transition name="fade">
            <div class="custom-modal" v-show="showManualFixModal">
                <div class="custommodal-backdrop"></div>
                <div class="custom-modal-inner">
                    <div class="custom-modal-header">
                        <h5 class="modal-title">Los de onderstaande problemen op:</h5>
                        <button type="button" @click="showManualFixModal=false" aria-label="Close" class="close">×</button>
                    </div>
                    <div class="custom-modal-body detail-list">
                        <b-alert show variant="warning">
                            <strong>Bestaande {{ fixes.subjects.join(', ').replace(/,(?!.*,)/gmi, ' en ') }} gevonden</strong>
                            <p>Controleer of de gevonden resultaten overheen komen en kies of deze behouden moet(en) worden.</p>
                        </b-alert>

                        <div class="sub-group contacts mt-3">

                            <div class="row">
                                <div class="col-md-6">
                                    <strong>Ingevulde gegevens:</strong>
                                    <p>
                                        {{contact.name}}<br />
                                        <strong>E-mailadres:</strong> {{contact.email}}<br />
                                        <strong>Telefoonnummer:</strong> {{contact.phone}}<br />
                                        <strong>KvK:</strong> {{contact.kvk}}
                                    </p>
                                </div>
                                <div class="col-md-6 d-flex justify-content-center">
                                    <button @click="keepcontact()" class="btn btn-sm btn-light">Ingevulde organisatie behouden <i class="fas fa-chevron-right"></i></button>
                                </div>
                            </div>

                            <h6><strong>Overeenkomsten:</strong></h6>

                            <div class="result-header">
                                <div class="list-group list-group-flush mr-3">
                                    <div class="list-group-item">
                                        <div class="text-sm-left d-flex justify-content-between align-items-center">
                                            <div style="flex-grow: 2; flex-basis:0;"><strong>T</strong></div>
                                            <div style="flex-grow: 10; flex-basis:0;"><strong>Naam</strong></div>
                                            <div style="flex-grow: 10; flex-basis:0;"><strong>Plaats</strong></div>
                                            <div style="flex-grow: 10; flex-basis:0;"><strong>E-mailadres</strong></div>
                                            <div style="flex-grow: 5; flex-basis:0;"><strong>Telefoonnummer</strong></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="results">
                                <div class="list-group list-group-flush">
                                    <a @click="finish(result)" v-for="result in fixes.data.contacts" class="list-group-item">

                                        <div class="d-flex justify-content-between align-items-center text-sm-left">
                                            <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                            <div style="flex-grow: 10; flex-basis:0;">{{result.name ? result.name : '-'}}</div>
                                            <div style="flex-grow: 10; flex-basis:0;">{{result.city ? result.city : '-'}}</div>
                                            <div style="flex-grow: 10; flex-basis:0;">{{result.email ? result.email : '-'}}</div>
                                            <div style="flex-grow: 5; flex-basis:0;">{{result.tel ? result.tel : '-'}}</div>
                                            <div>
                                                <i class="fas fa-chevron-right"></i>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import formKeys from './../../helpers/formKeys';
    import afasTitleSelect from './afasTitleSelect';
    import afasAddressInput from './afasAddressInput';
    import StepIndicator from 'vue-step-indicator';
    import VueTelInput from 'vue-tel-input';

    export default {
        components: {
            afasAddressInput,
            afasTitleSelect,
            StepIndicator,
            VueTelInput
        },
        data() {
            return {
                results: [],

                loaded: null,

                errors: [],
                validationErrors: [],

                q: '',

                contact: {
                    address: {
                        country: 'NL',
                        street: '',
                        number: '',
                        number_addition: '',
                        zip: '',
                        city: ''
                    },
                    title: 'ALG',
                    postaddres: {},
                    samePostaddress: true,
                    copyAddress: true
                },

                genders: [
                    {
                        value: "M",
                        key: "Dhr."
                    },{
                        value: "V",
                        key: "Mevr."
                    },{
                        value: "O",
                        key: "Geen aanhef"
                    },
                ],

                showManualFixModal: false,
                fixes: {
                    step: 1,
                    contacts: false,
                    addresses: false,
                    postaddresses: false,
                    subjects: [],
                    data: {
                        contacts: null,
                        addresses: null,
                        postaddresses: null
                    }
                },
                isUpdate: false
            }
        },
        props: {
            value: [Object, null],
            organisation: [Object, null],
            form: {
                type: Object,
                required: true,
            }
        },
        watch: {

        },
        mounted() {
        },
        computed: {
        },
        methods: {
            mappedKey(key) {
                return formKeys.mapKey(key, key);
            },
            shownModal() {
                this.$refs['con-letters'].focus();
            },
            show (contact = null) {
                this.$refs['form-create-contact'].show();

                // If a contact is passed to the show method,
                // use that contact to prefill the form
                if (contact) {
                    this.isUpdate = true;
                    this.setContact(contact);
                    setTimeout(() => {
                        this.validate();
                    }, 200);
                } else {
                    this.isUpdate = false;
                }
            },
            hide () {
                this.$refs['form-create-contact'].hide();
                this.$emit('canceled');
            },
            select(result) {
                this.$emit('input', result);
                this.hide();
            },
            setContact(contact) {
                if (contact.tel) {
                    contact.phone = contact.tel;
                }
                if (contact.hasOwnProperty('first_name')) {
                    contact.firstname = contact.first_name;
                }
                if (contact.hasOwnProperty('last_name')) {
                    contact.lastname = contact.last_name;
                }
                this.contact = Object.assign(this.contact, contact);
            },
            validate() {
                let err = [];
                if(this.contact.gender === undefined || this.contact.gender === null) {
                    err['con-gender'] = [
                        'Kies een aanhef.'
                    ];
                }
                if(this.contact.letters === undefined || this.contact.letters === null || this.contact.letters.length < 1) {
                    err['con-letters'] = [
                        'Vul geldige letters in, minimaal 1 teken.'
                    ];
                }
                if(this.contact.firstname === undefined || this.contact.firstname === null || this.contact.firstname.length < 2) {
                    err['con-firstname'] = [
                        'Vul een geldige voornaam in, minimaal 1 teken.'
                    ];
                }
                if(this.contact.lastname === undefined || this.contact.lastname === null || this.contact.lastname.length < 2) {
                    err['con-lastname'] = [
                        'Vul een geldige achternaam in, minimaal 1 teken.'
                    ];
                }
                if(this.contact.phone === undefined || this.contact.phone === null || !this.$refs['con-phone'].state) {
                    err['con-phone'] = [
                        'Vul een geldig telefoonnummer in.'
                    ];
                }
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(this.contact.email === undefined || this.contact.email === null || this.contact.email.length < 2 || !re.test(this.contact.email)) {
                    err['con-email'] = [
                        'Vul een geldig e-mailadres in.'
                    ];
                }

                let validAddress = true;
                let validPostAddress = true;
                if(!this.contact.copyAddress) {

                    validAddress = this.$refs.address.validate();
                    validPostAddress = (this.contact.samePostaddress || this.$refs.postaddress.validate());
                }

                this.validationErrors = err;
                return Object.keys(err).length === 0
                    && validAddress
                    && validPostAddress;
            },
            save() {
                if(this.validate()) {
                    this.$refs['form-create-contact'].hide();

                    if (this.isUpdate) {
                        return this.update();
                    }

                    this.$swal({
                        title: 'Bezig met toevoegen',
                        html: 'We versturen nu de data...',
                        allowOutsideClick: true,
                        onOpen: () => {
                            this.$swal.showLoading()
                        }
                    });

                    axios.post('/api/v1/leads/afas/contact/'+ this.organisation.afas_id, {
                        contact: this.contact,
                        form: this.form.id
                    })
                        .then(response => {

                            let steps = [];

                            this.fixes.contacts = (response.data.hasOwnProperty('contacts') && response.data.contacts.length > 0);

                            this.fixes.subjects = [];
                            if(this.fixes.contacts) {
                                this.fixes.subjects.push('Contactpersonen');

                                this.fixes.data.contacts = response.data.contacts;
                            }
                            this.fixes.step = 1;
                            if(this.fixes.contacts) {
                                this.$refs['form-create-contact'].show();
                                this.showManualFixModal = true;
                                this.$swal({
                                    type: 'warning',
                                    title: 'Bestaande ' + this.fixes.subjects.join(', ').replace(/,(?!.*,)/gmi, ' en ') +' gevonden',
                                    text: 'Controleer of de gevonden resultaten overheen komen en kies of deze behouden moet(en) worden.'
                                })
                            } else {
                                this.$swal({
                                    title: 'Succesvol toegevoegd',
                                    html: 'Nu nog even wachten totdat alles gesynchroniseerd is... <br />Huidige status: <strong>In afwachting van synchronisatie</strong>',
                                    allowOutsideClick: false,
                                    onOpen: () => {
                                        this.$swal.showLoading()
                                    }
                                });

                                this.checkJob(response.data.afas_nr, response.data.job_id);
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                type: 'error',
                                showConfirmButton: false,
                                html: this.$errorMessage(error)
                            });
                        });
                }
            },
            update() {
                this.$swal({
                    title: 'Bezig met opslaan',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: false,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                axios.put('/api/v1/leads/afas/contact/'+ this.organisation.afas_id, {
                    contact: this.contact,
                    form: this.form.id
                })
                .then(response => {
                    this.$swal({
                        title: 'Succesvol opgeslagen',
                        html: 'Nu nog even wachten totdat alles gesynchroniseerd is... <br />Huidige status: <strong>In afwachting van synchronisatie</strong>',
                        allowOutsideClick: false,
                        onOpen: () => {
                            this.$swal.showLoading()
                        }
                    });

                    this.checkJob(response.data.afas_nr, response.data.job_id);
                });
            },
            checkJob(afasNr, jobId) {
                //request check
                axios.get('/api/v1/leads/afas/contact/status/'+ jobId + '/' + this.organisation.afas_id + '/' + afasNr)
                    .then(response => {
                        if(response.data.status === 'finished') {
                            this.$swal({
                                toast: true,
                                position: 'top',
                                type: 'success',
                                title: 'Toegevoegd en geselecteerd!',
                                showConfirmButton: false,
                                timer: 3000,
                                backdrop: false
                            });
                            this.finish(response.data.data);
                        } else if(response.data.status === 'failed') {
                            this.$swal(
                                'Mislukt!',
                                'De synchronisatie is mislukt. Meld dit samen met de volgende code: ' + jobId + '-' + afasNr,
                                'error'
                            ).then((result) => {
                                this.$emit('formDeleted')
                            })
                        } else {
                            let status = 'Onbekend';
                            switch (response.data.status) {
                                case 'queued':
                                    status = 'In de wachtrij';
                                    break;
                                case 'executing':
                                    status = 'Bezig met synchroniseren';
                                    break;
                            }
                            this.$swal.getContent().querySelector('strong')
                                .textContent = status;

                            setTimeout(() => {
                                this.checkJob(afasNr, jobId);
                            }, 1000);
                        }
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            isInvalid(key) {
                if(this.validationErrors.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            keepcontact() {
                this.contact.force = true;
                if(this.fixes.addresses) {
                    this.fixes.step = 2;
                }
                else if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            selectAddress(result) {
                this.contact.address.id = result.address_nr;
                if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            selectPostaddress(result) {
                this.contact.postaddress.id = result.address_nr;

                this.showManualFixModal = false;
                this.save();
            },
            keepAddress() {
                this.contact.address.force = true;
                if(this.fixes.postaddresses) {
                    this.fixes.step = 3;
                }
                else {
                    this.showManualFixModal = false;
                    this.save();
                }
            },
            keepPostaddress() {
                this.contact.postaddress.force = true;
                this.showManualFixModal = false;
                this.save();
            },
            finish(contact) {
                this.showManualFixModal = false;
                this.$refs['form-create-contact'].hide();
                this.$emit('finished', contact);
            }
        }
    }
</script>

<style lang="scss">
    .phone-input {
        * {
            outline: none;
        }
        .dropdown {
            padding: 4px;
        }
        ul {
            z-index: 1000;
            li {
                font-size: 0.8em;
            }
        }
    }

    .custom-modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        display: none;
        overflow: hidden;
        outline: 0;
        overflow-x: hidden;
        overflow-y: auto;
        display: block;
        .custommodal-backdrop {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1050;
            background-color: green;
            opacity: 0.5;
        }
        .custom-modal-inner {
            max-width: 99%;
            position: relative;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            width: 100%;
            pointer-events: auto;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 0.3rem;
            outline: 0;
            z-index: 1060;
            min-height: 300px;
        }
        .custom-modal-body {
            padding: 16px;
        }
        .custom-modal-header {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            padding: 1rem;
            border-bottom: 1px solid #e9ecef;
            border-top-left-radius: 0.3rem;
            border-top-right-radius: 0.3rem;
        }
        @media (min-width: 576px) {
            .custom-modal-inner {
                max-width: 500px;
                margin: 14% auto;
            }
        }
        @media (min-width: 900px) {
            .custom-modal-inner {
                max-width: 800px;
                margin: 1.75rem auto;
            }
        }
    }
</style>